import { FlinksEvent } from '../../constants/bankIntegrationData';
import { sessionAtom } from '../../lib/recoil/persist';

const flinksModalUserState = sessionAtom<FlinksEvent | null >({
  key: 'flinksModalUserState',
  default: null,
});

export default flinksModalUserState;
